'use client';

import { MountainIcon } from '@/components/icons';
import { Button } from '@/components/ui/button';
import { Menu } from 'lucide-react';
import Link from 'next/link';
import { useState } from 'react';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="px-4 lg:px-6 h-16 flex items-center fixed w-full top-0 bg-[#5D3FD3] text-white z-50">
      <Link className="flex items-center justify-center" href="/">
        <MountainIcon className="h-6 w-6" />
        <span className="ml-2 text-lg font-semibold">DataConnector Pro</span>
      </Link>
      <nav className="hidden md:flex mx-6 items-center justify-center space-x-4 lg:space-x-6">
        <Link
          /* @ts-ignore */
          href="/#features"
          className="text-sm font-medium hover:text-[#B4F3F3] transition-colors"
        >
          Features
        </Link>
        <Link
          /* @ts-ignore */
          href="/#how-it-works"
          className="text-sm font-medium hover:text-[#B4F3F3] transition-colors"
        >
          How It Works
        </Link>
        <Link
          /* @ts-ignore */
          href="/#expertise"
          className="text-sm font-medium hover:text-[#B4F3F3] transition-colors"
        >
          Our Expertise
        </Link>
        <Link
          /* @ts-ignore */
          href="/#pricing"
          className="text-sm font-medium hover:text-[#B4F3F3] transition-colors"
        >
          Pricing
        </Link>
        <Link
          /* @ts-ignore */
          href="/#contact"
          className="text-sm font-medium hover:text-[#B4F3F3] transition-colors"
        >
          Contact
        </Link>
      </nav>
      <div className="ml-auto flex items-center space-x-4">
        <Button
          className="hidden md:inline-flex bg-[#B4F3F3] text-[#5D3FD3] hover:bg-[#A3E2E2] rounded-md rounded-md"
          asChild
        >
          <Link
            /* @ts-ignore */
            href="/#get-started"
          >
            Request a quote
          </Link>
        </Button>
        <Button className="md:hidden" variant="ghost" size="icon" onClick={() => setIsMenuOpen(!isMenuOpen)}>
          <Menu className="h-6 w-6" />
          <span className="sr-only">Toggle menu</span>
        </Button>
      </div>
      {isMenuOpen && (
        <div className="fixed inset-0 z-50 bg-[#5D3FD3] pt-16">
          <nav className="flex flex-col items-center space-y-4 p-4">
            <Link
              /* @ts-ignore */
              href="/#features"
              className="text-lg font-medium text-white hover:text-[#B4F3F3] transition-colors"
              onClick={() => setIsMenuOpen(false)}
            >
              Features
            </Link>
            <Link
              /* @ts-ignore */
              href="/#how-it-works"
              className="text-lg font-medium text-white hover:text-[#B4F3F3] transition-colors"
              onClick={() => setIsMenuOpen(false)}
            >
              How It Works
            </Link>
            <Link
              /* @ts-ignore */
              href="/#expertise"
              className="text-lg font-medium text-white hover:text-[#B4F3F3] transition-colors"
              onClick={() => setIsMenuOpen(false)}
            >
              Our Expertise
            </Link>
            <Link
              /* @ts-ignore */
              href="/#pricing"
              className="text-lg font-medium text-white hover:text-[#B4F3F3] transition-colors"
              onClick={() => setIsMenuOpen(false)}
            >
              Pricing
            </Link>
            <Link
              /* @ts-ignore */
              href="/#contact"
              className="text-lg font-medium text-white hover:text-[#B4F3F3] transition-colors"
              onClick={() => setIsMenuOpen(false)}
            >
              Contact
            </Link>
            <Button
              className="bg-[#B4F3F3] text-[#5D3FD3] hover:bg-[#A3E2E2] rounded-md"
              asChild
              onClick={() => setIsMenuOpen(false)}
            >
              {/* @ts-ignore */}
              <Link href="/#get-started">Request a quote</Link>
            </Button>
          </nav>
        </div>
      )}
    </header>
  );
}
